import { createSlice } from '@reduxjs/toolkit';
import type { ExploreState } from './types';

const initialState: ExploreState = {
  isLoading: false,
  error: false,
  pathways: [],
  hasMore: true,
  pageIndex: 0,
  pageStep: 12
};

export const slice = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    cleanExplore(state) {
      state.pathways = [];
      state.pageIndex = 0;
      state.pageStep = 11;
      state.hasMore = true;
    },
    getExploreInitial(state, action) {
      state.isLoading = false;
      state.pathways = [...state.pathways, ...action.payload];
    },
    noHasMore(state) {
      state.hasMore = false;
    },
    getMorePosts(state) {
      const setPageIndex = state.pageIndex + 1;
      state.pageIndex = setPageIndex;
    }
  }
});

export default slice.reducer;
export const { getMorePosts } = slice.actions;
